import React from 'react';
import {
    CircularProgressbar,
    CircularProgressbarWithChildren,
    buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import RadialSeparator from "./RadialSeparator";
import GradientSVG from "./GradientSVG";

import "./style.css"

const CircularProgressBar = ({ value = 0, max = 3, type = 1, forceValue = null, trailColor = "#fff", separatorColor = "#eaeaea" }) => {

    let progress = Math.round(value / max * 100);

    if (forceValue) {
        progress = forceValue;
    }

    if (progress == Infinity) {
        progress = 0;
    }

    return (
        <div id="custom-circular-progress-bar">
            <GradientSVG />
            {
                type == 1 && <>
                    <h1>{`${value}`}</h1>
                    <CircularProgressbarWithChildren
                        value={value / max * 100}
                        text=""
                        strokeWidth={10}
                        styles={buildStyles({
                            textColor: "#9fae95",
                            pathColor: "#9fae95",
                            trailColor: trailColor,
                            textSize: "3rem",
                            fontWeight: "100",
                            fontFamily: "Josefin Sans Thin",
                            strokeLinecap: "butt",
                            margin: "10px",
                        })}
                    >
                        <RadialSeparator
                            count={3}
                            style={{
                                background: separatorColor,
                                width: "4px",
                                // This needs to be equal to props.strokeWidth
                                height: `${10}%`
                            }}
                        />
                    </CircularProgressbarWithChildren>
                </>
            }

            {
                type == 2 && <>
                    <h4>{`${progress}%`}</h4>
                    <CircularProgressbar
                        value={progress} text=""
                        styles={buildStyles({
                            textColor: "#3d3d3d",
                            pathColor: "#9fae95",
                            trailColor: trailColor,
                            textSize: "2rem",
                            fontWeight: "100",
                            fontFamily: "Josefin Sans Thin"
                        })}
                    />
                </>
            }

        </div>
    );
};

export default CircularProgressBar;